import React from 'react';
import { motion } from 'framer-motion';
import './AddressCard.css';

export default function AddressCard({
  address,
  isSelected,
  onSelect,
  onEdit,
  onDelete,
  onSetDefault,
  showActions = true,
}) {
  const handleSelect = () => {
    if (onSelect) {
      onSelect(address);
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(address);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(address.id);
    }
  };

  const handleSetDefault = (e) => {
    e.stopPropagation();
    if (onSetDefault && !address.isDefault) {
      onSetDefault(address.id);
    }
  };

  const getTypeIcon = () => {
    switch (address.addressType) {
      case 'HOME': return '🏠';
      case 'WORK': return '💼';
      default: return '📍';
    }
  };

  return (
    <motion.div
      className={`address-card ${isSelected ? 'selected' : ''}`}
      onClick={handleSelect}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="address-card-selector">
        <div className={`radio-indicator ${isSelected ? 'checked' : ''}`}>
          {isSelected && <div className="radio-fill"></div>}
        </div>
      </div>

      <div className="address-card-content">
        <div className="address-card-header">
          <div className="address-meta">
            <span className="address-type-badge">{getTypeIcon()} {address.addressType}</span>
            {address.isDefault && <span className="default-badge">Default</span>}
          </div>
        </div>

        <div className="address-card-body">
          <p className="address-name">{address.fullName}</p>
          <p className="address-phone">{address.mobile}</p>
          <p className="address-line">{address.addressLine1}</p>
          {address.addressLine2 && (
            <p className="address-line">{address.addressLine2}</p>
          )}
          {address.landmark && (
            <p className="address-landmark">Near: {address.landmark}</p>
          )}
          <p className="address-location">
            {address.city}, {address.state} - {address.pincode}
          </p>
        </div>

        {showActions && (
          <div className="address-card-actions">
            <button className="action-btn edit-btn" onClick={handleEdit}>
              Edit
            </button>
            <button className="action-btn delete-btn" onClick={handleDelete}>
              Delete
            </button>
          </div>
        )}
      </div>
    </motion.div>
  );
}
